// extracted by mini-css-extract-plugin
module.exports = {"container":"StarRating_container__2iniD","star":"StarRating_star__E1jXK","yellowStar":"StarRating_yellowStar__3qyhr"};